<template>
  <div class="ps-px-6 ps-py-4 ps-bg-white hover:ps-bg-blue-100 ps-rounded">
    <a
      :href="page.url"
      target="_blank"
      class="ps-text-brand-brown-800  ps-text-sm ps-no-underline ps-flex ps-items-center"
    >
      <span class="ps-flex-auto ps-mr-4 ps-leading-normal">
        <h5 class="ps-mb-1 ps-text-base ps-leading-tight">{{ page.title }}</h5>
        <p class="ps-mt-2">{{ page.url }}</p>
      </span>
      <span class="ps-w-8  ps-svg-down ps-text-xs">
        <button-icon
          :size="10"
          bg-color="brand-brown-400 ps-rounded"
          color="white"
        >
          <svg-icon name="go" width="16" height="auto" />
        </button-icon>
      </span>
    </a>
  </div>
</template>

<script>
import ButtonIcon from '@/components/buttons/ButtonIcon'
import '@/icons/go'
export default {
  name: 'PageItem',
  props: {
    page: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ButtonIcon
  }
}
</script>
